import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import vi from "date-fns/locale/vi";
import AutoSearchPeople from "../../../../../components/auto-search-people";
import BusRouteController from "../../../../../services/system/bus/bus-route-controller";
import BusTypeController from "../../../../../services/system/bus/bus-type-controller";
import Utils from "../../../../../utils/utils";
import Dropzone from "react-dropzone";
import FilesApi from "../../../../../services/resource/files-api";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class CreateBusManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            assistant1Id: "",
            assistant1Name: "",
            assistant1Username: "",

            assistant2Id: "",
            assistant2Name: "",
            assistant2Username: "",

            assistant3Id: "",
            assistant3Name: "",
            assistant3Username: "",

            assistant1: "",
            assistant2: "",
            assistant3: "",

            driverId: "",
            driverName: "",
            driverUsername: "",
            zone: "",
            serviceImage: "",

            name: "",
            seatNumber: 0,
            state: "ACTIVE",
            yearId: parseInt(getSchoolYear()),

            activeDate: null,
            content: "",

            listPointBus: [],
            busTypePriceRes: [],
        };
    }
    componentWillMount() {
        this.getListBusType()
    }
    getListBusType() {
        let payload = {
            pageNumber: 0,
            pageSize: 100,
            state: "ACTIVE",
            sort: "created_at desc"
        };
        BusTypeController.list(payload, res => {
            this.setState({
                showLoading: false,
                busTypePriceRes: res.data.content,
            });
        })
    }
    renderBusType() {
        return this.state.busTypePriceRes.map((item, index) =>
            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                <label className="col-6 label-item pl-0">{item.name}</label>
                <input
                    placeholder="Nhập SĐT tài xế"
                    maxLength={255} type="text"
                    className="form-control shadow-none"
                    value={Utils.formatMoney(this.state.busTypePriceRes[index]["price"] == undefined?0:this.state.busTypePriceRes[index]["price"])}
                    onChange={(event) => {
                        let price = parseFloat(event.target.value.toString().replaceAll(",", ""))
                        this.state.busTypePriceRes[index]["price"] = price
                        this.setState(this.state.busTypePriceRes);
                    }}
                />
            </div>)
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "INACTIVE",
                "name": "Đã khóa"
            },
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    showImage(){
        if (this.state.serviceImage.length > 0){
            FilesApi.showFile(this.state.serviceImage, res=>{
                this.setState({
                    imgFile: res
                })
            })
        }
    }
    onUpImage = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    serviceImage: res.data.url,
                }, () => {
                    toast.success('Tải ảnh thành công!')
                    this.showImage()
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    onCreate = () => {
        let {name, seatNumber} = this.state;
        if (name == "" || name.length < 5){
            toast.error("Tên tuyến phải lớn hơn 6 ký tự");
        }else if(seatNumber < 5){
            toast.error("Tổng số chỗ ngồi phải lớn hơn 5");
        }else {
            let busStopReqs = []
            let busRouteTypeReqs = []

            this.state.listPointBus.forEach(pointObj => {
                busStopReqs.push({
                    "location": pointObj["location"],
                    "name": pointObj["name"],
                    "timeDon": pointObj["timeDon"],
                    "timeTra": pointObj["timeTra"]
                })
            })
            this.state.busTypePriceRes.forEach(pointObj => {
                if (pointObj["price"] != undefined){
                    busRouteTypeReqs.push({
                        "busTypeId": parseInt(pointObj["id"]),
                        "price": pointObj["price"]
                    })
                }
            })
            if (busRouteTypeReqs.length < 1){
                toast.error("Vui lòng cấu hình giá dịch vụ");
            }else if (this.state.assistant1Id=="" && this.state.assistant2Id=="" && this.state.assistant3Id==""){
                toast.error("Vui lòng chọn phụ xe");
            }else if (busStopReqs.length < 1){
                toast.error("Vui lòng thêm điểm đón xe bus");
            }else {
                let payload = {
                    "assistant1Id": this.state.assistant1Id==""?-1: this.state.assistant1Id,
                    "assistant2Id": this.state.assistant2Id==""?-1: this.state.assistant2Id,
                    "assistant3Id": this.state.assistant3Id==""?-1: this.state.assistant3Id,
                    "busStopReqs": busStopReqs,
                    "busRouteTypeReqs": busRouteTypeReqs,
                    "driverName": this.state.driverName,
                    "driverPhone": this.state.driverPhone,
                    "name": this.state.name,
                    "seatNumber": parseInt(this.state.seatNumber),
                    "state": this.state.state,
                    "zone": this.state.zone,
                    "serviceImage": this.state.serviceImage,
                    "yearId": parseInt(getSchoolYear()),
                }
                console.log(payload)
                BusRouteController.create(payload, res => {
                    if (res.success){
                        this.props.navigate('/ad-sas-school/danh-sach-tuyen-xe-bus');
                        toast.success("Tạo tuyến xe bus thành công!")
                    } else {
                        toast.error("Đã xảy ra lỗi! " + res.message)
                    }
                })
            }
        }
    }
    onAddPoint(){
        let newPoint = {
            "id": this.state.listPointBus.length,
            "name": "",
            "location": "",
            "timeDon": "",
            "timeTra": ""
        }
        this.state.listPointBus.push(newPoint)
        this.setState(this.state.listPointBus);
    }
    onDelPoint(index) {
        this.state.listPointBus.splice(index, 1)
        this.setState(this.state.listPointBus);
    }
    renderListPoint() {
        return this.state.listPointBus.map((item, index) =>
                <div className="col-12 d-flex mb-2 row">
                    <label className="col-12 label-item pl-0">Điểm số {index+1}</label>
                    <div className="col-12 d-flex mb-2 square border border-primary p-2 row">
                        <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                            <label className="col-2 label-item pl-0">Tên tuyến xe Bus</label>
                            <input
                                placeholder="Nhập tên điểm xe bus"
                                maxLength={255} type="text"
                                className="form-control shadow-none"
                                value={item.name}
                                onChange={(event) => {
                                    this.state.listPointBus[index].name = event.target.value
                                    this.setState(this.state.listPointBus)
                                }}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                            <label className="col-4 label-item pl-0">Địa chỉ Google Map</label>
                            <input
                                placeholder="Ví dụ: https://goo.gl/maps/8DJF1yZJzj7fn4Gq7)"
                                maxLength={255} type="text"
                                className="form-control shadow-none"
                                value={item.location}
                                onChange={(event) => {
                                    this.state.listPointBus[index].location = event.target.value
                                    this.setState(this.state.listPointBus)
                                }}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2 mt-2">
                            <a href={this.state.listPointBus[index].location==""?"https://www.google.com/maps": this.state.listPointBus[index].location} target="_blank" rel="noopener noreferrer">
                                (Ấn để mở Google Map)
                            </a>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                            <label className="col-4 label-item pl-0">Thời gian đón</label>
                            <input
                                placeholder="Nhập giờ đón: 10:15)"
                                maxLength={255} type="text"
                                className="form-control shadow-none"
                                value={item.timeDon}
                                onChange={(event) => {
                                    this.state.listPointBus[index].timeDon = event.target.value
                                    this.setState(this.state.listPointBus)
                                }}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                            <label className="col-4 label-item pl-0">Thời gian trả</label>
                            <input
                                placeholder="Nhập giờ trả: 10:15"
                                maxLength={255} type="text"
                                className="form-control shadow-none"
                                value={item.timeTra}
                                onChange={(event) => {
                                    this.state.listPointBus[index].timeTra = event.target.value
                                    this.setState(this.state.listPointBus)
                                }}
                            />
                        </div>
                        <div className="align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                    onClick={()=> {
                                        this.onDelPoint(index)
                                    }}
                                >
                                    Xóa
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }

    render() {
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name}-{file.size} bytes
            </li>
        ));
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-bus" parentClass="bus-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm mới tuyến xe bus"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI TUYẾN XE BUS</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên tuyến xe Bus</label>
                                                <input
                                                    placeholder="Nhập tên tuyến xe bus"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="label-item col-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổng số chỗ</label>
                                                <input
                                                    placeholder="Nhập tổng số chỗ xe bus"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.seatNumber}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            seatNumber: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Khu vực</label>
                                                <input
                                                    placeholder="Khu vực đón"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.zone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            zone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nhập tên tài xế</label>
                                                <input
                                                    placeholder="Nhập tên tài xế"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.driverName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            driverName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nhập SĐT tài xế</label>
                                                <input
                                                    placeholder="Nhập SĐT tài xế"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.driverPhone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            driverPhone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn phụ xe 1</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.assistant1Id}
                                                    principalName={this.state.assistant1Name}
                                                    principalUsername={this.state.assistant1Username}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({assistant1Id: principalId, assistant1Name: principalName, assistant1Username: principalUsername})}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn phụ xe 2</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.assistant2Id}
                                                    principalName={this.state.assistant2Name}
                                                    principalUsername={this.state.assistant2Username}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({assistant2Id: principalId, assistant2Name: principalName, assistant2Username: principalUsername})}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn phụ xe 3</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.assistant3Id}
                                                    principalName={this.state.assistant3Name}
                                                    principalUsername={this.state.assistant3Username}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({assistant3Id: principalId, assistant3Name: principalName, assistant3Username: principalUsername})}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2"></div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 label-item pl-0">Icon hiển thị ở ứng dụng</label>
                                                <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                                          onDrop={acceptedFiles => {
                                                              this.setState({files: acceptedFiles}, () =>{
                                                                  this.onUpImage()
                                                              })
                                                          }}
                                                          multiple={false}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section className="container-upload col-md-10">
                                                            <div {...getRootProps({className: 'dropzone'})}>
                                                                <img width="200px" key={this.state.imgFile} src={this.state.imgFile} />
                                                                <input {...getInputProps()} />
                                                                {files.length > 0 ? <div className="align-center">
                                                                    <ul>{files}</ul>
                                                                </div> : <p>Chọn tập tin để upload 1</p>}
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Giá loại dịch vụ xe bus
                                            </div>
                                            {this.renderBusType()}
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách điểm đón xe bus
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2 mt-2">
                                                <a href="https://www.google.com/maps/@20.9802753,105.7703291,15z" target="_blank" rel="noopener noreferrer">
                                                    Ấn để mở Google Map để chọn kinh độ và vĩ độ các điểm xe sẽ đón/trả học sinh
                                                </a>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                                    onClick={()=> {
                                                        this.onAddPoint()
                                                    }}
                                                >
                                                    Thêm điểm đón
                                                </button>
                                            </div>
                                            <div className="row mt-3">
                                                {this.renderListPoint()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/danh-sach-tuyen-xe-bus"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateBusManagement)
